import {useQuery} from '@tanstack/react-query';
import {AxiosError, AxiosResponse} from 'axios';
import {AxiosErrorToast} from '../general/ReusableFunctions';
import {IStation} from '../../dto/Station.dto';
import {IApiDataResponse} from '../../dto/API.dto';
import axiosInstance from '../../axiosConfig';

export const getTaskStationsApiPath = (taskId: number) =>
  `/v1/task/${taskId}/station-name`;

type IStationWithError = IStation & {error?: string | null};

const getTaskStations = (taskId: number) => {
  return axiosInstance
    .get(getTaskStationsApiPath(taskId))
    .then((response: AxiosResponse<IApiDataResponse<IStationWithError[]>>) => {
      return response.data?.data;
    })
    .catch((error: AxiosError) => {
      AxiosErrorToast(error, 'Error in listing stations');
      throw error;
    });
};

export const useRqListPrepopulatedStations = (
  taskId: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: [getTaskStationsApiPath(taskId)],
    queryFn: () => getTaskStations(taskId),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled,
  });
};
